// *************  Transactions admin Table Data *********
export const TableKeys = [
  "transaction_id",
  "date",
  "payer",
  "amount",
  "status",
];

export const TableHeaders = [
  "Transaction ID",
  "Transaction Date",
  "Payer",
  "Amount",
  "Status",
];

export const TableData = [
  {
    id: "1",
    transaction_id: { type: "string", value: "0123456789034567" },
    date: { type: "string", value: "10-09-2023." },
    payer: { type: "string", value: "Company name" },
    amount: { type: "string", value: "1000" },
    status: {
      type: "string",
      value: "approved",
      jsx: (
        <div className="status-approved">
          <span className="status-dot approved" /> Approved
        </div>
      ),
    },
  },
  {
    id: "2",
    transaction_id: { type: "string", value: "0123456789034567" },
    date: { type: "string", value: "10-09-2023." },
    payer: { type: "string", value: "Company name" },
    amount: { type: "string", value: "1000" },
    status: {
      type: "string",
      value: "approved",
      jsx: (
        <div className="status-approved">
          <span className="status-dot approved" /> Decline
        </div>
      ),
    },
  },
  {
    id: "3",
    transaction_id: { type: "string", value: "0123456789034567" },
    date: { type: "string", value: "10-09-2023." },
    payer: { type: "string", value: "Company name" },
    amount: { type: "string", value: "1000" },
    status: {
      type: "string",
      value: "approved",
      jsx: (
        <div className="status-approved">
          <span className="status-dot approved" /> Approved
        </div>
      ),
    },
  },
];
